// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/loteria/extracao/extracao.css
// module id = 1032
// module chunks = 0